var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message)+" "+_vm._s(_vm.progressPercent)+"%")]),_c('div',{staticClass:"bar",style:({width:_vm.progressPercent+'%'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }